import React from 'react';
import { Header } from './Header';
import { Footer } from './Footer';
import { StickyMobileCTA } from './StickyMobileCTA';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="min-h-screen flex flex-col" data-id="element-341">
      <Header data-id="element-342" />
      <main className="flex-grow" data-id="element-343">{children}</main>
      <Footer data-id="element-344" />
      {/* Bottom spacer so the sticky mobile CTA never covers footer content */}
      <div className="md:hidden h-16" aria-hidden="true" data-id="element-345" />
      <StickyMobileCTA data-id="element-346" />
    </div>;
}